var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mb-4"},[_c('AdvisorSchedule')],1),_c('div',[_c('AdvisorChat')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }